export const APP_VERSION = '0.0.630.20261102152857';
